import { render, staticRenderFns } from "./CreateContent.vue?vue&type=template&id=5cfd29a4&scoped=true&"
import script from "./CreateContent.vue?vue&type=script&lang=js&"
export * from "./CreateContent.vue?vue&type=script&lang=js&"
import style0 from "./CreateContent.vue?vue&type=style&index=0&id=5cfd29a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfd29a4",
  null
  
)

export default component.exports